import defaultSettings from '../settings.json';
export interface GlobalState {
  settings?: typeof defaultSettings;
  userInfo?: {
    name?: string;
    avatar?: string;
    job?: string;
    organization?: string;
    location?: string;
    email?: string;
    permissions?: Record<string, string[]>;

    root?: boolean; // 是否是超管员
    roleId?: number;
    userId?: number;
  };
  userLoading?: boolean;
  isLogin?: boolean;
}

const initialState: GlobalState = {
  settings: defaultSettings,
  userInfo: {
    permissions: {},
  },
  isLogin: false,
};

export default function store(state = initialState, action) {
  switch (action.type) {
    case 'update-settings': {
      const { settings } = action.payload;
      return {
        ...state,
        settings,
      };
    }
    case 'update-userInfo': {
      const { userInfo = initialState.userInfo, userLoading } = action.payload;
      return {
        ...state,
        userLoading,
        userInfo,
      };
    }
    case 'update-isLogin': {
      const { isLogin } = action.payload;
      return {
        ...state,
        isLogin,
      };
    }
    default:
      return state;
  }
}
